import { Component, OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import { JobSearchComponent } from '../../job-search/job-search.component';
import { JobAlertComponent } from '../../job-alert/job-alert.component';

@Component({
  selector: 'sts-job-info',
  templateUrl: './job-info.component.html'
})
export class JobInfoComponent implements OnInit {

  jobSearchComponent: any = JobSearchComponent;
  jobAlertComponent: any = JobAlertComponent;

  constructor(
    public navCtrl: NavController
  ) { }

  ngOnInit() {
  }

  jobAlert() {
    this.navCtrl.push(this.jobAlertComponent);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/job-info/job-info.component.ts